import { View, GridColumn, colors } from '@fairygodboss/ui';
import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

import ResponsivePicture from '../../components/Images/ResponsiveImage';
import { AuthWrapper } from '../../components/SharedLayout/AuthWrapper/AuthWrapper';
import { frola } from '../../styles/frola';
import { stripAdPlaceholderText } from '../../utils/helperFunctions';
import useUser from '../../utils/useUser';

import { ConvincerWithBullets, ConvincerButton } from './Convincer';

const bodyInLineCSS = {
    a: {
        textDecoration: 'underline !important',
        ':visited': {
            color: `${colors.secondary[70]} !important`,
        },
        position: 'relative',
        maxWidth: '100%',
    },
};
const CTAButton = ({ windowWidth }) => {
    const [hasCookieBanner, setHasCookieBanner] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            const cookeBannerEl = document.getElementById('cookie-banner');
            if (cookeBannerEl) {
                setHasCookieBanner(true);
            }
        }, [100]);
    }, []);

    return (
        <AuthWrapper
            redirectUrl="/community/feed"
            loginTrigger="article_join_sticky_button"
            customMetric={{
                fireMultiple: true,
            }}
        >
            <View
                position="fixed"
                right={{ _: '0px', sm: '24px' }}
                justifyContent={{ _: 'center', sm: 'end' }}
                width="100%"
                bottom={{
                    _: hasCookieBanner ? '144px' : '16px',
                    sm: hasCookieBanner ? '88px' : '16px',
                }}
                zIndex="10"
                display={{ _: '-webkit-box', md: 'none' }}
            >
                <ConvincerButton
                    text="Join the community"
                    windowWidth={windowWidth}
                />
            </View>
        </AuthWrapper>
    );
};

const displayBodyContent = (contentToDisplay) => {
    const {
        type, content, alt, caption, style, classes, width, height
    } = contentToDisplay;
    const id = uuid();
    if (type === 'HTML') {
        const viewProps = {
            style: bodyInLineCSS,
            as: 'span',
            dangerouslySetInnerHTML: {
                __html: stripAdPlaceholderText(content),
            },
        };
        return <View key={id} {...viewProps} />;
    }

    if (type === 'IMAGE') {
        return (
            <View key={id} style={bodyInLineCSS}>
                <span className={classes}>
                    <style jsx>
                        {`
                            .fr-img-caption {
                                ${style}
                            }
                        `}
                    </style>
                    <span className="fr-img-wrap">
                        <ResponsivePicture
                            cloudinaryID={content}
                            alt={alt}
                            autoWidth={true}
                        />
                        <View
                            as="span"
                            className="fr-inner"
                            dangerouslySetInnerHTML={{
                                __html: caption,
                            }}
                        />
                    </span>
                </span>
            </View>
        );
    }
    if (type === 'IMAGEOLD') {
        return (
            <View key={id} style={bodyInLineCSS}>
                <span className={classes}>
                    <style jsx>
                        {`
                            .fr-img-wrap-old {
                                text-align: center;
                            }
                        `}
                    </style>
                    <span>
                        <ResponsivePicture
                            cloudinaryID={content}
                            alt={alt}
                            width={width}
                            height={height}
                            baseClass="fr-img"
                        />
                    </span>
                </span>
            </View>
        );
    }
    return <> </>;
};
const DeconstructedBodyContent = (props) => {
    const { contentBody } = props;
    return (
        <View className="fr-view fr-view-deconstructed">
            <style jsx>
                {`
                    ${frola}
                `}
            </style>
            {contentBody.map((x) => displayBodyContent(x))}
        </View>
    );
};

export const MainArticleBody = ({ contentBody, windowWidth }) => {
    const { user, userLoading } = useUser();
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    }, []);

    return (
        <View display="flex" justifyContent="flex-start" className="fr-view">
            {!user?.isLoggedIn && !userLoading && isReady ? (
                <CTAButton windowWidth={windowWidth} />
            ) : (
                <></>
            )}
            {' '}
            <GridColumn
                size={{
                    xs: 12,
                    sm: 12,
                    md: 7.8,
                    lg: 7.6,
                }}
                pt={{ _: '24px', sm: '32px' }}
                pl={{ _: '0px', sm: '0px' }}
                pr={{ _: '0px', sm: '0px' }}
            >
                <DeconstructedBodyContent contentBody={contentBody} />
            </GridColumn>
            <GridColumn
                size={{
                    xs: 0,
                    sm: 0,
                    md: windowWidth > 1054 ? 3 : 4.0,
                    lg: 3.05,
                }}
                ml={{ _: 'auto' }}
                display={{ _: 'none', md: 'block' }}
                pr={{ _: '0px', md: '24px', lg: '0px' }}
                css={{
                    paddingLeft: '0px',
                }}
            >
                {!user?.isLoggedIn && !userLoading && isReady ? (
                    <>
                        <View height="380px" />
                        <View position="sticky" top="119px">
                            <ConvincerWithBullets location="article" />
                        </View>
                    </>
                ) : (
                    <></>
                )}
            </GridColumn>
        </View>
    );
};

MainArticleBody.displayName = 'MainArticleBody';
